<div class="container load-content">
	<div class="row justify-content-center">
		<div class="col-12 col-lg-4 text-center big-logo-page">
            <div class="logo d-flex justify-content-center">
                <img src="assets/images/logo-light.svg" alt="logo-atalaya-light">
            </div>

            <div *ngIf="!active_error">
                <h3>{{ 'ACTIVATE.title_ok' | translate }}</h3>
                <p>{{ 'ACTIVATE.ok' | translate}}</p>
            </div>
            <div *ngIf="active_error">
                <h3>{{ 'ACTIVATE.title_error' | translate }}</h3>
                <p>{{ 'ACTIVATE.error' | translate}}</p>
            </div>
		</div>
    </div>
  <app-progress-bar></app-progress-bar>
</div>
